<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mb-3 mt-4">
            Facility Registers
          </div>
        </v-layout>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'U1', tags: 'C1'}"
        v-if="this.licenceOK &&
        this.userOK &&
        this.getUser.pref.select.cauth !== null"/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'O1', tags: 'O1'}"/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'W1', tags: 'W1'}"/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'B3', tags: 'B3'}"/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'A.F1', tags: 'A.F1'}"/>
      </v-container>
      <v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mb-3 mt-4">
            Facility Objectives
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.obj"
            label="facility operartional mission and vision"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="operational objectives"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mb-3 mt-4">
            Facility Performance Indicators
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.kpi"
            label="Description of how to measure success"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="measurable key performance indicators"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-2 mb-3">
            Management and Settings
          </div>
        </v-layout>
        <v-btn :color="ui.btnColor" flat light :disabled="true">
          <v-icon left>
            crop_square
          </v-icon>
          Facility Areas
        </v-btn>
        <v-btn :color="ui.btnColor" flat light :disabled="true">
          <v-icon left>
            grid_view
          </v-icon>
          Facility Units
        </v-btn>
        <v-btn :color="ui.btnColor" flat light :disabled="true">
          <v-icon left>
            linear_scale
          </v-icon>
            Functional Systems
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              shield
            </v-icon>
            Key Facility Decisions
          </v-btn>
        </v-container>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
    </v-form>
  </div>
</template>

<script>
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true,
      localForm: {
        kpi: "",
        obj: ""
      },
      orgForm: {
        kpi: "",
        obj: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.kpi = this.getDetail.char.kpi;
    this.localForm.obj = this.getDetail.char.obj;

    this.orgForm.kpi = this.getDetail.char.kpi;
    this.orgForm.obj = this.getDetail.char.obj;
  },
  components: {
    GetRegisterListPage,
    GetAccessListPage
  },
  // eslint-disable-next-line
  mixins: [apptheme, licenceFunctions, adminFunctions, docRevsModFunctions, ruleTextfield],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.kpi !== this.orgForm.kpi &&
        this.localForm.kpi !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.kpi = this.localForm.kpi;
        // basic
        char.kpi = this.localForm.kpi;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.obj !== this.orgForm.obj &&
        this.localForm.obj !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.obj = this.localForm.obj;
        // basic
        char.obj = this.localForm.obj;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
